module.exports = __webpack_public_path__ + "static/linkedlist-hero-0ee8c28e963c25de598ba5f0e9b3d9c7.png";